import { Box, Button, Group, Text } from "@mantine/core";
import { BBox } from "components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { TransactionsTable } from "./components";

export const Transactions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <BBox
      header={
        <Group position="apart">
          <Text size="sm" weight={500}>
            {t("TRANSACTIONS_LIST")}
          </Text>
          <Button onClick={() => navigate("new")}>{t("ADD_NEW")}</Button>
        </Group>
      }
    >
      <Box p="xl">
        <TransactionsTable />
      </Box>
    </BBox>
  );
};
